import React from "react";
import {
  CssBaseline,
  Box,
  CircularProgress,
} from "@mui/material";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import Home from "./pages/Home";
import AnnotationSheet from "./pages/AnnotationSheet";
import { AnnotationProvider } from "./contexts/AnnotationContext";
import AuthPage from "./pages/Auth";
import Tutorial from "./pages/Tutorial";
import { ViewModeProvider } from "./contexts/ViewModeContext";
import { useCustomAuth } from "./contexts/AuthContext";
import Users from "./pages/Users";

function App() {
  const auth = useAuth();
  const {userData, isAdminMode} = useCustomAuth();
  const isAdmin = userData?.roles.includes("ADMIN") || userData?.roles.includes("ROOT") || false

  const handleLogout = async () => {
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const logoutUri = `${process.env.REACT_APP_DOMAIN}/login`;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

    await auth.removeUser(); // Clear local session
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (auth.error) {
    return <div>Error: {auth.error.message}</div>;
  }

  const isAuthenticated = auth.isAuthenticated;

  return (
    <Router>
      <CssBaseline />
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <AuthPage />} />

        {/* Protected Routes */}
        <Route path="/" element={isAuthenticated ? <Home handleLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/tutorial" element={isAuthenticated ? <Tutorial handleLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/users" element={isAuthenticated ? (isAdmin && isAdminMode) ? <Users handleLogout={handleLogout} /> : <Home handleLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/annotation/:sheetId/:view" element={isAuthenticated ? <ViewModeProvider><AnnotationProvider><AnnotationSheet handleLogout={handleLogout} /></AnnotationProvider></ViewModeProvider> : <Navigate to="/login" />} />
        
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;
